import { Drawer, useTheme } from "@mui/material";
import SidebarNav from "./components/SidebarNav";

interface SidebarProps {
    open: boolean;
    variant: "permanent" | "persistent" | "temporary" | undefined;
    onClose: () => void;
}

const Sidebar = ({ open, variant, onClose }: SidebarProps) => {
    const theme = useTheme();

    return (
        <Drawer
            anchor="left"
            onClose={() => onClose()}
            open={open}
            variant={variant}
            sx={{
                "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: 256,
                    top: { xs: 0, md: 71 },
                    height: { xs: "100%", md: "calc(100% - 71px)" },
                    background: theme.palette.alternate.main,
                },
            }}
        >
            <SidebarNav />
        </Drawer>
    );
};

export default Sidebar;
